import {
  FETCH_REPEAT_PAYMENT_OFFER,
  RESET_REPEAT_PAYMENT_OFFER,
} from 'constants/payment';
import type { Offer } from 'models/offer';

type RepeatPaymentOfferAction =
  | { type: typeof FETCH_REPEAT_PAYMENT_OFFER; payload: Offer }
  | { type: typeof RESET_REPEAT_PAYMENT_OFFER };

const repeatPaymentOffer = (
  state: Offer | Record<string, never> = {},
  action: RepeatPaymentOfferAction,
) => {
  switch (action.type) {
    case FETCH_REPEAT_PAYMENT_OFFER:
      return action.payload;
    case RESET_REPEAT_PAYMENT_OFFER:
      return {};
    default:
      return state;
  }
};

export { repeatPaymentOffer };
